import React from 'react';
import EstablishmentManagement from '../Management';

const actions = {
    start: "CREATE_ESTABLISHMENT_SUBMIT",
    resolve: "CREATE_ESTABLISHMENT_SUCCESS",
    reject: "CREATE_ESTABLISHMENT_FAILED"
};

const NewEstablishment = () => (
    <EstablishmentManagement
        headerName="Cadastrar Estabelecimento"
        actions={actions}
    />
);

export default NewEstablishment;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/New/index.js